/**
 * i18n messages for the public certificate details page (en/ar). Registered in
 * core/plugins/i18n.ts under its own `publicCertificate` namespace key. The
 * page shows both languages at once (English, then Arabic right-to-left), as
 * the guideline viewer's not-available line does. CSP-safe compiler: only
 * `{named}` placeholders.
 */
export const publicCertificateMessages = {
  en: {
    publicCertificate: {
      title: "Certificate Details",
      clientInfo: "Client Info",
      uidCode: "UID Code",
      currentStatus: "Current Status",
      statusActive: "Active",
      lastAudit: "Last Shari'a Audit",
      lastAuditValue:
        "Please contact +973 17215898 to learn about the status of Sharia audit",
      shariaOpinion: "Sharia Opinion",
      viewDocument: "View Document",
      remarks: "Remarks",
      documentsReviewed: "Document(s) Reviewed",
      product: "Approved Fund / Product",
      reportIssue: "Report Issue/Fraud",
      viewCertificate: "View Certificate",
      uploadedPdfNote:
        "Please scan the QR code on your certificate or contact {email}.",
      footer:
        "If you have any problems using the search engine to verify your certificate, please contact us at {email}",
      notFound: "This certificate is not available.",
      loading: "Loading…",
      pictureUnavailable:
        "This picture is not available. If you searched for this certificate, please search again.",
      logoAlt: "Client logo",
      pictureAlt: "Certificate",
      close: "Close",
      searchLabel: "Certificate number",
      searchButton: "Verify",
      searchNoMatch: "No active certificate matches this number.",
      searchRateLimited:
        "Too many attempts — please wait a minute and try again",
      searchFound: "Certificate found.",
    },
  },
  ar: {
    publicCertificate: {
      title: "تفاصيل الشهادة",
      clientInfo: "معلومات العميل",
      uidCode: "الرمز المرجعي (UID)",
      currentStatus: "الحالة الحالية",
      statusActive: "سارية",
      lastAudit: "آخر تدقيق شرعي",
      lastAuditValue:
        "يرجى الاتصال على +973 17215898 للاطلاع على حالة التدقيق الشرعي",
      shariaOpinion: "الرأي الشرعي",
      viewDocument: "عرض المستند",
      remarks: "ملاحظات",
      documentsReviewed: "المستندات التي تمت مراجعتها",
      product: "الصندوق / المنتج المعتمد",
      reportIssue: "الإبلاغ عن مشكلة / احتيال",
      viewCertificate: "عرض الشهادة",
      uploadedPdfNote:
        "يرجى مسح رمز QR الموجود على شهادتك أو التواصل عبر {email}.",
      footer:
        "إذا واجهتك أي مشكلة في استخدام محرك البحث للتحقق من شهادتك، يرجى التواصل معنا على {email}",
      notFound: "هذه الشهادة غير متاحة.",
      loading: "جارٍ التحميل…",
      pictureUnavailable:
        "هذه الصورة غير متاحة. إذا بحثت عن هذه الشهادة، يرجى البحث مرة أخرى.",
      logoAlt: "شعار العميل",
      pictureAlt: "الشهادة",
      close: "إغلاق",
      searchLabel: "رقم الشهادة",
      searchButton: "تحقق",
      searchNoMatch: "لا توجد شهادة سارية مطابقة لهذا الرقم.",
      searchRateLimited:
        "محاولات كثيرة جدًا — يرجى الانتظار دقيقة ثم المحاولة مرة أخرى",
      searchFound: "تم العثور على الشهادة.",
    },
  },
};
